module.exports = __webpack_public_path__ + "static/media/SM pooling.ce13231b.svg";